import { useTheme } from "@emotion/react";
import {
  DefaultButton,
  Dialog,
  DialogContent,
  DialogType,
  PrimaryButton,
} from "@fluentui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Flex } from "../styled";

type Props = {
  handleReset: () => void;
  disabled: boolean;
};

function ResetMailConfig({ handleReset, disabled }: Props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const [openDialog, setOpenDialog] = useState(false);

  const toggleDialog = () => {
    setOpenDialog((prev) => !prev);
  };

  return (
    <>
      <StyledCancelBtn
        disabled={disabled}
        text={t("rvm.resetMailConfig.label")}
        onClick={toggleDialog}
        style={{
          border: theme.palette.redDark,
          background: theme.palette.redDark,
        }}
        allowDisabledFocus={true}
      />
      <Dialog
        hidden={!openDialog}
        onDismiss={toggleDialog}
        dialogContentProps={{
          type: DialogType.normal,
          title: <div>{t("rvm.resetMailConfig.label")}</div>,

          showCloseButton: true,
        }}
        minWidth={400}
        modalProps={{
          isBlocking: true, //phraseActivated ? false :
        }}
      >
        <DialogContent>
          <Flex justifyContent="center" gap={15}>
            <PrimaryButton
              text={t("greco.yes")}
              onClick={handleReset}
              allowDisabledFocus={true}
            />
            <DefaultButton
              text={t("greco.no")}
              onClick={toggleDialog}
              allowDisabledFocus
              disabled={disabled}
            />
          </Flex>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ResetMailConfig;

const StyledCancelBtn = styled(PrimaryButton)``;
